import React from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './dice.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, TextArea, FormSelect } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { checkDuplicateName } from '~/utils/validators.yup';
import { API_PREFIX } from './dice.api';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';

DiceForm.defaultProps = {
    pictureAttributeNames: null,
};
DiceForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function DiceForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const { boons, alignments } = useSelector((state) => state.heroSaga.dice);

    return (
        <>
            {!isEmpty(initialValues) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values } = props;
                                const asyncApiCall = checkDuplicateName(initialValues.name, API_PREFIX);

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Form.Row>
                                            <FormText
                                                sm="3"
                                                name="name"
                                                asyncApiCall={asyncApiCall}
                                                className="d-flex flex-column justify-content-end"
                                            />
                                            {pictureAttributeNames.map((imgName, i) => (
                                                <Col
                                                    key={i}
                                                    sm={3}
                                                    className={'offset-sm-1'}
                                                >
                                                    <FileUploadedWithResetCount
                                                        pictureName={imgName}
                                                        pictureVal={values[imgName]}
                                                        resetCount={resetCount}
                                                        className={'offset-sm-1'}
                                                        id={imgName}
                                                    />
                                                </Col>
                                            ))}
                                            <FormSelect
                                                name={'alignmentId'}
                                                sm={3}
                                                className="offset-sm-1 d-flex flex-column justify-content-end"
                                                options={alignments}
                                            />
                                        </Form.Row>

                                        <Form.Row>
                                            <TextArea
                                                name={'description'}
                                                sm={3}
                                                rows={3}
                                            />
                                            <FormSelect
                                                name={'boonId'}
                                                sm={3}
                                                className={'offset-sm-1'}
                                                options={boons}
                                            />
                                        </Form.Row>
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default DiceForm;
